import React from 'react';
import { CarrierExpeditionStartOutDTO } from '@api/ringil-api.v2';
import {
  dayjsFromApiPrague,
  dayjsFromApiUtc,
  formatDateFromDayjsInTzWithLocale,
  formatTimeIntervalFromDayjsIntervalWithLocale,
} from '@utils/dateWithTz.tsx';
import { useTranslation } from 'react-i18next';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';

interface ComponentProps {
  label: string;
  expeditionStart?: CarrierExpeditionStartOutDTO;
  userTimezoneId: string;
  valueTestId?: string;
}

const ExpeditionListStart: React.FC<ComponentProps> = ({ label, expeditionStart, userTimezoneId, valueTestId }) => {
  const { t }: { t: any } = useTranslation('common');

  console.log('ExpeditionListStart - expeditionStart:', expeditionStart, 'userTimezoneId:', userTimezoneId);

  const dayJsFromUtcStart = dayjsFromApiUtc(expeditionStart?.utcStart)
  const dayjsFromUtcEnd = dayjsFromApiUtc(expeditionStart?.utcEnd)
  const dayJsFromSince = dayjsFromApiPrague(expeditionStart?.since)
  const dayjsFromTill = dayjsFromApiPrague(expeditionStart?.till)
  const utcStartDateShort = dayJsFromUtcStart && expeditionStart?.timezoneId ? formatDateFromDayjsInTzWithLocale(dayJsFromUtcStart, expeditionStart.timezoneId) : null
  const utcEndDateShort = dayjsFromUtcEnd && expeditionStart?.timezoneId ? formatDateFromDayjsInTzWithLocale(dayjsFromUtcEnd, expeditionStart.timezoneId) : null
  const sinceDateShort = dayJsFromSince ? formatDateFromDayjsInTzWithLocale(dayJsFromSince, userTimezoneId) : null
  const tillDateShort = dayjsFromTill ? formatDateFromDayjsInTzWithLocale(dayjsFromTill, userTimezoneId) : null
  const timeIntervalFromUtc = dayJsFromUtcStart && dayjsFromUtcEnd && expeditionStart?.timezoneId ? formatTimeIntervalFromDayjsIntervalWithLocale(dayJsFromUtcStart, dayjsFromUtcEnd, expeditionStart.timezoneId) : null
  const timeIntervalFromPrague = dayJsFromSince && dayjsFromTill ? formatTimeIntervalFromDayjsIntervalWithLocale(dayJsFromSince, dayjsFromTill, userTimezoneId) : null

  return (
    <>
      <div>
        <div>
          <small>{label}</small>
        </div>

        {/* Expedition start is not exists => show predefined text = termin nezadan*/}
        {!expeditionStart && <div data-testid={valueTestId}>{t(`ExpeditionListStart.no_time`, `Termín nezadán`)}</div>}

        {/* Expedition start is exists, till is null => show only since day = 10.05.2022*/}
        {expeditionStart && expeditionStart.utcStart && !expeditionStart.utcEnd ? (
          <div data-testid={valueTestId}>
            {utcStartDateShort}
            <COTimezone dataTestId={`${valueTestId}-timezone`} timezoneId={expeditionStart.timezoneId}/>
          </div>
        ) : (
          expeditionStart && !expeditionStart.till &&
          <div data-testid={valueTestId}>
            {sinceDateShort}
            <COTimezone dataTestId={`${valueTestId}-timezone`} timezoneId={userTimezoneId}/>
          </div>
        )}

        {/* Expedition start is exists, till is not null, show dates is false => show only since day with time interval = 10.05.2022 14:00 - 15:00*/}
        {expeditionStart && expeditionStart.utcEnd && !expeditionStart.showDates ? (
          <div data-testid={valueTestId}>
            {utcStartDateShort} {timeIntervalFromUtc}
            <COTimezone dataTestId={`${valueTestId}-timezone`} timezoneId={expeditionStart.timezoneId}/>
          </div>
        ) : (
          expeditionStart && expeditionStart.till && !expeditionStart.showDates &&
          <div data-testid={valueTestId}>
            {sinceDateShort} {timeIntervalFromPrague}
            <COTimezone dataTestId={`${valueTestId}-timezone`} timezoneId={userTimezoneId}/>
          </div>

          )}

        {/* Expedition start is exists, till is not null, show dates is true => show interval of days = 10.05.2022 - 12.05.2022*/}
        {expeditionStart && expeditionStart.showDates && (
          expeditionStart.utcStart && expeditionStart.utcEnd ? (
            <div data-testid={valueTestId}>
              {utcStartDateShort} - {utcEndDateShort}
              <COTimezone dataTestId={`${valueTestId}-timezone`} timezoneId={expeditionStart.timezoneId}/>
            </div>
          ): (
            <div data-testid={valueTestId}>
              {sinceDateShort} - {tillDateShort}
              <COTimezone dataTestId={`${valueTestId}-timezone`} timezoneId={userTimezoneId}/>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default ExpeditionListStart;
